import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setGalleryDIYBannerAnalyticsSent } from 'shared/actions/newbuildingBrokerDIY';
import { NewbuildingBrokerGalleryBanner } from 'shared/components/NewbuildingBrokerGalleryBanner';
import { NBSP } from 'shared/constants';
import { selectFullscreenGalleryOpened } from 'shared/selectors/gallery';
import { selectGalleryDIYBannerAnalyticsSent } from 'shared/selectors/newbuildingBrokerDIY';
import { trackDIYEntryPointClick, trackDIYEntryPointShow } from 'shared/utils/newbuildingBroker/DIY';

const SOURCE = 'card_independent_banner_at_gallery';

export const NewbuildingBrokerGalleryDIYBannerContainer = () => {
  const isFullscreen = useSelector(selectFullscreenGalleryOpened);
  const isLoading = false; // TODO: Будет реализовано в CD-262356.
  const galleryBannerAnalyticsSent = useSelector(selectGalleryDIYBannerAnalyticsSent);

  const dispatch = useDispatch();

  const handleShow = React.useCallback(() => {
    if (!galleryBannerAnalyticsSent) {
      trackDIYEntryPointShow(SOURCE);
      dispatch(setGalleryDIYBannerAnalyticsSent());
    }
  }, [dispatch, galleryBannerAnalyticsSent]);

  const handleClick = React.useCallback(() => {
    trackDIYEntryPointClick(SOURCE);
    // TODO: Реализовать открытие DIY в CD-262356
  }, []);

  return (
    <NewbuildingBrokerGalleryBanner
      isFullscreen={isFullscreen}
      title={`Бесплатно найдём новостройку под${NBSP}ваш бюджет`}
      buttons={
        <ActionAfterViewObserver callback={handleShow} wrapper={false}>
          <Button theme="fill_primary" loading={isLoading} onClick={handleClick}>
            Заполнить заявку
          </Button>
        </ActionAfterViewObserver>
      }
    />
  );
};
